import React from "react";
import { css } from "emotion";
import { boxStyles } from "../styles/theme";
import LogoTitle from "./sidebar/LogoTitle";
import SidebarTitle from "./sidebar/SidebarTitle";
import Menu from "./sidebar/Menu";

const Sidebar = ({title, subtitle}) => {
  return (
    <div className={container}>
      <LogoTitle />
      <SidebarTitle title={title} subtitle={subtitle} />
      <Menu />
    </div>
  );
};

export default Sidebar;

const container = css`
  border-radius: 0 10px 10px 0;
  flex: 1;
  box-shadow: ${boxStyles.boxShadow};
  position: fixed;
  width: 320px;
  height: 100%;
  z-index: 1;
  background-color: #fefefe;
`;
